import { Map } from 'leaflet';
import PropTypes from 'prop-types';

export default PropTypes.instanceOf(Map);


//////////////////
// WEBPACK FOOTER
// ./~/react-leaflet/es/propTypes/map.js
// module id = 93
// module chunks = 0